<template>
  <rhcn-drawer @on-close="onClose" v-loading="loading">
    <div class="drawer-form exchange-form" style="width: 637px;">
      <div>
        <rhcn-step :steps="steps"></rhcn-step>
      </div>
      <div>
        <el-form ref="formRef" :model="form" class="form-relactive" :rules="formRules">
          <!-- you sell -->
          <rhcn-currency-amount ref="sellRef" :label="$t('message.exchange.youSell')"
            :placeholder="sellAmountPlaceholder" input-prop="amount" select-prop="sellCurrency"
            :input-value.sync="form.amount" :select-value.sync="form.sellCurrency" :options="sellCurrencyList"
            :option="{ currency: 'value', amount: 'amount' }" @on-blur="getRate('SELL')" @on-input="handleInputNum"
            @on-change="changeSellCurrency"></rhcn-currency-amount>
          <div class="rate-wrapper">
            <div class="line"></div>
            <div class="rate-content">
              <div class="close-icon">
                <span class="el-icon-close"></span>
              </div>
              <div class="rate-text">
                <span class="rate-amount">{{ form.rate }}</span>
                <span class="time">{{ $t('message.exchange.referenceRate') }}</span>
              </div>
            </div>
          </div>
          <!-- You buy -->
          <rhcn-currency-amount ref="buyRef" :placeholder="buyAmountPlaceholder" :label="$t('message.exchange.youBuy')"
            input-prop="buyAmount" select-prop="buyCurrency" :input-value.sync="form.buyAmount"
            :select-value.sync="form.buyCurrency" :options="buyCurrencyList" @on-blur="getRate('BUY')"
            @on-input="handleInputbuyNum" :option="{ currency: 'value', amount: 'amount' }"
            @on-change="changeBuyCurrency"></rhcn-currency-amount>
        </el-form>
      </div>
      <div class="exchange-date">
        <div class="label">{{ $t('message.exchange.deliveryDate') }}</div>
        <el-input class="input" type="text" :value="today" disabled size="small"></el-input>
      </div>
      <!-- 不为 B2B 时，显示提示信息 -->
      <div v-if="`${app.userLogin.businessType}` !== '0'" class="exchange-tips margin-top-30">
        <p>{{ $t('message.exchange.exchangeTips1') }}</p>
      </div>
      <div class="margin-top-30">
        <el-button :disabled="!supportFx" :loading="loading" style="width:100%;" type="primary" @click="submit">{{
          $t('message.exchange.continue') }}</el-button>
      </div>
      <div class="margin-top-14" v-if="!supportFx">
        <span class="iconfont icon-warning exchange-warning"></span>
        <span class="exchange-warning-message">
          <span>{{ $t('message.exchange.holidayTip') }}</span>
          <a href="/static/files/Currency-Holiday-Calendar-2023.pdf" class="view" target="_blank">{{
            $t('message.exchange.seeDetails') }}</a>
        </span>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import RhcnCurrencyAmount from '@/components/form/currency-amount.vue';
import RhcnStep from '@/components/step/index.vue';
import { validateFns, REQUIRED } from '@/components/validation/tool/validator';
import GlobalData from '@/utils/global/index';
import { getCurrencyImage } from '@/utils/tools/currency';
import { formatDateDisplay } from '@/utils/tools/time';
import BalancesService from '@/views/settlement/api/settlement-balance';
import ExchangeService from '@/views/wallet/api/exchange';

export default {
  components: { RhcnDrawer, RhcnStep, RhcnCurrencyAmount },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      loading: true,
      today: formatDateDisplay(new Date(), 'yyyy-MM-dd'),
      form: {
        sellCurrency: '',
        buyCurrency: '',
        amount: '',
        buyAmount: '',
        sellAmount: '',
        rate: '',
      },
      sendAmount: '',
      formRules: {
        // sellCurrency: [
        //   { validator: validateFns([REQUIRED]) },
        // ],
        // buyCurrency: [
        //   { validator: validateFns([REQUIRED]) },
        // ],
        amount: [
          // { validator: validateFns([REQUIRED]) },
          { validator: this.validateSellAmount },
        ],
        // buyAmount: [
        //   // { validator: validateFns([REQUIRED]) },
        //   { validator: this.validateBuyAmount },
        // ],
      },
      steps: [
        {
          title: 'message.exchange.amount',
        },
        {
          title: 'message.exchange.review',
        },
      ],
      accountBalances: [],
      buyCurrencyListOrigin: [],
      sellCurrencyList: [],
      buyCurrencyList: [],
      supportFx: true,
      sellAmountPlaceholder: '',
      buyAmountPlaceholder: '',
      buyCurrencyListMap: {
      },
      fixCurrencyList: [],
      buySell: 'SELL',
    };
  },
  async created() {
    const userLogin = this.app.userLogin;
    await GlobalData.getDictList(['SWAP_RATE_CURRENCY']).then((res) => {
      // this.buyCurrencyListMap = res.SWAP_RATE_CURRENCY;
      this.buyCurrencyListMap = res.SWAP_RATE_CURRENCY.map(item => item.value);
      console.log(this.buyCurrencyListMap, 'guanbuycurrencylistmap');
    });
    // 发起币种
    await BalancesService.getAccountBalances().then((data) => {
      this.accountBalances = data;
      const sellList = [];
      const buyList = [];
      this.buyCurrencyListMap.forEach(currencyValue => {
        // sellList.push({
        //   value: currencyValue,
        //   amount: '0.00', // 初始化amount为空
        // });
        buyList.push({
          value: currencyValue,
          amount: '0.00',
        });
      });

      // 2. 遍历data数据，找到匹配的currency并设置amount
      data.forEach(item => {
        // 查找sellList中是否有匹配的value
        this.buyCurrencyListMap.map(currey => {
          if (currey === item.availBalance.currency) {
            sellList.push({
              value: currey,
              amount: item.availBalance.amount || '0.00',
            });
          }
        });
        const matchedBuyItem = buyList.find(buyItem => buyItem.value === item.availBalance.currency);
        if (matchedBuyItem) {
          matchedBuyItem.amount = item.availBalance.amount || '0.00';
        }
      });
      this.sellCurrencyList = sellList;
      this.buyCurrencyList = buyList;
      // console.log(sellList, 'guanselllist');
      if (sellList.length) {
        this.form.sellCurrency = sellList[0];
        this.sellAmountPlaceholder = this.form.sellCurrency.amount;
      }
      if (buyList.length) {
        this.form.buyCurrency = buyList[0];
        this.buyAmountPlaceholder = this.form.buyCurrency.amount;
      }
    }).catch(() => ({}));
    this.loading = false;
  },
  methods: {
    onClose() {
      this.$router.push({
        path: '/wallet/exchange',
      });
    },
    getRate(type) {
      console.log('触发了吗', type);
      console.log(this.sendAmount, 'guansendamount', this.form.sellCurrency, this.form.buyCurrency, this.form.sellCurrency.amount);
      let num = null;
      if (type === 'SELL') {
        num = this.form.sellCurrency.amount;
      } else {
        num = this.form.buyCurrency.amount;
      }
      if ((this.sendAmount) && this.form.sellCurrency && this.form.buyCurrency) {
        const userLogin = this.app.userLogin;
        // 类型不为 B2B 时，最小金额为 10
        if (userLogin && (userLogin.businessType !== '0') && Number(this.form.sendAmount) < 10) {
          return;
        }
        this.loading = true;
        this.buySell = type;
        ExchangeService.getExchangeRate({
          sellCurrency: this.form.sellCurrency.value,
          buyCurrency: this.form.buyCurrency.value,
          amount: this.sendAmount,
          buySell: type,
        }).then((res) => {
          this.loading = false;
          this.form.rate = res.convRate;
          this.form.buyAmount = res.buyAmount;
          this.form.amount = res.sellAmount;
          this.supportFx = res.supportFx;
        }).catch(() => {
          this.form.rate = '';
          this.form.buyAmount = '';
          this.loading = false;
        });
      }
    },
    changeBuyCurrency() {
      this.changeType('BUY');
      // if (this.form.sellCurrency && this.form.buyCurrency && this.form.sellCurrency.value === this.form.buyCurrency.value) {
      //   this.form.buyCurrency = '';
      // }
      if (!isNaN(Number(this.sellAmountPlaceholder))) {
        this.sellAmountPlaceholder = this.form.sellCurrency.amount;
      }
      this.getRate('BUY');
    },
    changeSellCurrency() {
      const userLogin = this.app.userLogin;
      if (userLogin && (userLogin.businessType !== '0')) {
        // if (this.form.sellCurrency && this.form.buyCurrency && this.form.sellCurrency.value === this.form.buyCurrency.value) {
        //   this.form.buyCurrency = '';
        // }
      }
      this.changeType('SELL');
      if (!isNaN(Number(this.sellAmountPlaceholder))) {
        this.sellAmountPlaceholder = this.form.sellCurrency.amount;
      }
      this.getRate('SELL');
    },
    changeType(type) {
      // buySell
      if (type === 'SELL') {
        if (this.buyCurrencyList.length) {
          // this.form.buyCurrency = this.buyCurrencyList[0];
          this.$refs.formRef.validateField(['amount']);
          if (!isNaN(Number(this.sellAmountPlaceholder))) {
            this.sellAmountPlaceholder = this.form.sellCurrency.amount;
          }
        }
      } else {
        if (this.sellCurrencyList.length) {
          // this.form.sellCurrency = this.sellCurrencyList[0];
          this.$refs.formRef.validateField(['buyAmount']);
          if (!isNaN(Number(this.buyAmountPlaceholder))) {
            this.buyAmountPlaceholder = this.form.buyCurrency.amount;
          }
        }
      }
      this.buySell = type;
      this.getRate(type);
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (this.form.sellCurrency.value === this.form.buyCurrency.value) {
          this.$message.error(this.$t('message.exchange.sameCurrency'));
          return;
        }
        if (valid && this.form.rate) {
          this.$router.push({
            path: '/wallet/exchange/add/review',
            query: {
              sell: this.form.sellCurrency.value,
              buy: this.form.buyCurrency.value,
              amount: this.sendAmount,
              date: this.today,
              buySell: this.buySell,
            },
          });
        }
      });
    },
    handleInputNum(value) {
      console.log(value, 'guanvalue');
      const v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      this.form.amount = v;
      this.sendAmount = v;
      this.$refs.sellRef.inputInnerValue = v;
      // this.$refs.buyRef.inputInnerValue = v;
      // 卖出金额placeholder
      if (!isNaN(this.sellAmountPlaceholder) && this.form.amount !== '') {
        this.sellAmountPlaceholder = `${this.$t('message.validator.input', { input: this.$t('message.transfer.amount').toLowerCase() })}`;
      }
    },
    handleInputbuyNum(value) {
      console.log('触发了吗2', value);
      console.log(value, 'guanvalue');
      const v = value.match(/^\d*(\.?\d{0,2})/g)[0];
      this.sendAmount = v;
      // this.form.amount = v;
      this.form.buyAmount = v;
      this.$refs.buyRef.inputInnerValue = v;
      if (!isNaN(this.buyAmountPlaceholder) && this.form.amount !== '') {
        this.buyAmountPlaceholder = `${this.$t('message.validator.input', { input: this.$t('message.transfer.amount').toLowerCase() })}`;
      }
      // this.$refs.buyRef.inputInnerValue = v;
    },
    validateSellAmount(rule, value, callback) {
      if (this.buySell === 'SELL' && Number(this.form.amount) > Number(this.form.sellCurrency.amount)) {
        callback(new Error(this.$t('message.transfer.insufficientBalance')));
        return;
      }
      const userLogin = this.app.userLogin;
      // 类型不为 B2B 时，最小金额为 10
      if (userLogin && (userLogin.businessType !== '0') && Number(this.form.amount) < 10) {
        callback(new Error(this.$t('message.transfer.limitMinAmount')));
        return;
      }
      callback();
    },
    validateBuyAmount(rule, value, callback) {
      console.log(this.form.buyAmount, 'guanbuyamount', this.form.buyCurrency.amount);
      if (this.buySell === 'BUY' && Number(this.form.buyAmount) > Number(this.form.buyCurrency.amount)) {
        callback(new Error(this.$t('message.transfer.insufficientBalance')));
        return;
      }
      const userLogin = this.app.userLogin;
      // 类型不为 B2B 时，最小金额为 10
      if (userLogin && (userLogin.businessType !== '0') && Number(this.form.buyAmount) < 10) {
        callback(new Error(this.$t('message.transfer.limitMinAmount')));
        return;
      }
      callback();
    },
    getCurrencyImage,
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.exchange-form {
  margin-top: -68px;

  .exchange-warning {
    color: $color-icon-warn;
    margin-right: 7px;
    font-size: 19px;
  }

  .exchange-warning-message {
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;

    .view {
      font-size: 16px;
      font-weight: bold;
      line-height: 32px;
      color: $color-success;
    }
  }

  .exchange-tips {
    font-size: 16px;
    font-weight: bold;
  }
}

.form-relactive {
  margin-top: 110px;

  .rate-wrapper {
    width: 100%;
    position: relative;
    height: 103px;
    overflow: hidden;

    .line {
      width: 3px;
      height: 103px;
      background: $color-default;
      display: inline-block;
      margin: 0 0 0 22px;
      padding: 0;
      border: 0;
    }

    .rate-content {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;

      .close-icon {
        display: inline-block;
        width: 23px;
        height: 23px;
        background: $color-default;
        border-radius: 50%;
        text-align: center;
        line-height: 23px;

        .el-icon-close {
          line-height: 23px;
          font-weight: bold;
        }
      }

      .rate-text {
        display: flex;
        margin-left: 13px;
        align-items: center;

        .rate-amount {
          font-size: 14px;
          font-weight: bold;
          line-height: 23px;
        }

        .time {
          margin-left: 32px;
          font-size: 14px;
          font-weight: 400;
          line-height: 23px;
        }
      }
    }
  }
}

.exchange-date {
  margin-top: 40px;

  .label {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 8px;
  }

  .input {
    width: 325px;
  }
}
</style>
